// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-flex[data-v-47dd2157]{height:calc(85vh - 96px)}@media (max-width:960px){.map-flex[data-v-47dd2157]{height:450px}}@media (max-width:600px){.map-flex[data-v-47dd2157]{height:450px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
